import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button, Card, Checkbox, Container, FormControl, IconButton, InputLabel, Link, MenuItem, Paper, Popover, Select, Stack, Table, TableBody, TableCell, TableHead, TableContainer, TablePagination, TableRow, Typography, Tooltip } from '@mui/material'
import DummyData from '../sections/@dashboard/requests/dummyData'
import { Link as RouterLink } from 'react-router-dom';
import { getAllIssue } from './qualityApi'
import { useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { QUALITY_ROLES } from '../../common/constants';
import { fDate } from '../../common/common-sidebar/utils/formatTime';
import { RemoveRedEyeIcon } from '../../common/icons';


function IssueATC() {
    const rows = DummyData;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [allIssues, getAllIssues] = useState([]);
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - allIssues.length) : 0;

    const [isEnabled, setisEnabled] = useState(false);

    let inspectorEmail = localStorage.getItem("InspectorEmail");
    let userType = localStorage.getItem("role");
    // console.log(inspectorEmail, "email ins");

    useEffect(() => {
        getAllIssue().then((res) => {

            if (userType == QUALITY_ROLES.Inspector) {
                var filterIns = res.filter((item) => { return item?.inspectorEmail == inspectorEmail })
                getAllIssues(filterIns);
            } else {
                getAllIssues(res);
            }
            // res = res.filter((item) => { return item?.inspectorEmail == inspectorEmail && item?.inspectorName == "quality" })

            console.log(res, "res")
        }).catch((e) => {
            console.log(e);
        })

        var userDetail = localStorage.getItem('role')
        if (userDetail == QUALITY_ROLES.QualityModuleIncharge) {
            setisEnabled(true);
        } else {
            setisEnabled(false);
        }
    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const issueColumns = [
        {
            field: 'issueNumber', headerName: 'Issue Number', width: 110,
            renderCell: (params) => {
                // console.log(params.row, "params")
                return (
                    <>
                        <Link component={RouterLink} to={`issueatc1/${params?.row?.issueNumber}`} style={{ cursor: "pointer" }}>{params?.row?.issueNumber}</Link>
                    </>
                )
            }
        },
        { field: 'inspectionWorkOrderId', headerName: 'Work Order ID', width: 110 },
        { field: 'materialCode', headerName: 'Material Code', width: 110 },
        { field: 'inspectionCategory', headerName: 'Inspection Category', width: 150 },
        // { field: 'alertSendSuccessfully', headerName: 'Alert send successfully', width: 180 },
        { field: 'invoiceOnHoldTillQCClearance', headerName: 'Invoice Status' },
        { field: 'qualityParameter', headerName: 'Quality Parameter', width: 132 },
        { field: 'inspectorName', headerName: 'Inspector', width: 150 },
        { field: 'deviation', headerName: 'Deviation', width: 100 },
        { field: 'measurementLocation', headerName: 'Measurement location', width: 160 },
        { field: 'measuringInstrument', headerName: 'Measuring Instrument', width: 160 },
        { field: 'consignmentId', headerName: 'Consignment No', width: 120 },
        { field: 'lotNumber', headerName: 'Bundle ID', width: 85 },
        {
            field: 'restricted', headerName: 'Restricted/Unrestricted', width: 175,
            valueGetter: (params) =>
                `${params.row.restricted ? 'Restricted' : 'Unrestricted'}`,
        },
        { field: 'measured_quantity', headerName: 'Actual quantity', width: 140 },
        { field: 'toleranceLimit', headerName: 'Tolerance Limit', width: 120 },
        { field: 'createdBy', headerName: 'Issue Generated By', width: 148 },
        { field: 'recordedQuantity', headerName: 'Recorded Quantity', width: 140 },
        { field: 'newQuantity', headerName: 'New Recorded Quantity', width: 140 },
        { field: 'actionTakenClosureReport', headerName: 'Action taken closure report', width: 100 },
        { field: 'ATC submitted by', headerName: 'Review & Approved by', width: 100 },
        {
            field: 'ATC submitted on', headerName: 'Review & Approved on', width: 120,
            renderCell: (params) => {
                return (
                    <div>{fDate(params?.value, 'dd/MM/yyyy')}</div>
                )
            }
        },
        { field: 'status', headerName: 'Status', width: 90 },
        {
            field: 'Action', headerName: 'Action', width: 90, renderCell: (params) => {
                // console.log(params.row, "params")
                if (params.row.status == 'Open' && params.row.actionTakenClosureReport !== null && params.row.reviewerComment == null || params.row.status == "Clarification" && params.row.actionTakenClosureReport !== null && params.row.reviewerComment !== null) {
                    // console.log(params.row, "params");
                    return (
                        <>
                            <Tooltip title="Review">
                                <IconButton color="primary" size="large" hidden={!isEnabled} component={RouterLink} to={`IssueATCReview/${params.row.issueNumber}`}>
                                    <RemoveRedEyeIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    )
                } else {
                    return (
                        <p>-</p>
                    )
                }
            }
        },
    ]



    return (
        <>
            <Helmet>
                <title> Issue & ATC | ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 2 }}>
                    Issue & ATC
                </Typography>
                <Card style={{ padding: "3%" }}>
                    <Box sx={{ height: 400, width: '100%' }}>
                        <DataGrid
                            rows={allIssues}
                            columns={issueColumns}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 5,
                                    },
                                },
                            }}
                            pageSizeOptions={[5]}
                            getRowId={(row) => row.issueNumber}
                            components={{ Toolbar: QuickSearchToolbar }}
                        // checkboxSelection
                        // disableRowSelectionOnClick
                        />
                    </Box>
                    {/* <TableContainer component={Paper}>
                        <Scrollbar>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Unique Issue Number</TableCell>
                                        <TableCell>Work Order ID</TableCell>
                                        <TableCell align="center">Material Code</TableCell>
                                        <TableCell align="center">Inspection Category</TableCell>
                                        <TableCell align="center">Alert send successfully</TableCell>
                                        <TableCell align="center">Invoice on hold till QC clearance(Transportaion invoice status)</TableCell>
                                        <TableCell align="center">Quality Parameter </TableCell>
                                        <TableCell align="center">Inspector </TableCell>
                                        <TableCell align="center">Measurement location </TableCell>
                                        <TableCell align="center">Measuring Instrument </TableCell>
                                        <TableCell align="center">Consignment ID </TableCell>
                                        <TableCell align="center">Bundle ID </TableCell>
                                        <TableCell align="center">Restricted/Unrestricted </TableCell>
                                        <TableCell align="center">Measured quantity </TableCell>
                                        <TableCell align="center">Tolerance Limit </TableCell>
                                        <TableCell align="center">Issue Generated By </TableCell>
                                        <TableCell align="center">Recorded Quantity </TableCell>
                                        <TableCell align="center" style={{ background: '#62b6ff' }}>Action taken closure report </TableCell>
                                        <TableCell align="center" style={{ background: '#62b6ff' }}>Review & Approved by </TableCell>
                                        <TableCell align="center" style={{ background: '#62b6ff' }}>Review & Approved on </TableCell>
                                        <TableCell align="center" style={{ background: '#62b6ff' }}>Status </TableCell>
                                        <TableCell align="center" style={{ background: '#62b6ff' }}> </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(rowsPerPage > 0
                                        ? allIssues.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : allIssues
                                    ).map((row) => (
                                        <TableRow
                                            key={row.issueNumber}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Link variant="subtitle2" underline="hover" component={RouterLink} to={`issueatc1/${row.issueNumber}`}>{row.issueNumber}</Link>
                                            </TableCell>
                                            <TableCell align='center'> {row.inspectionWorkOrderId} </TableCell>
                                            <TableCell align="center">{row.materialCode}</TableCell>
                                            <TableCell align="center">{row.inspectionCategory}</TableCell>
                                            <TableCell align="center">{row.alertSendSuccessfully}</TableCell>
                                            <TableCell align="center">{row.invoiceOnHoldTillQCClearance}</TableCell>
                                            <TableCell align="center">{row.qualityParameter}</TableCell>
                                            <TableCell align="center">{row.inspector} </TableCell>
                                            <TableCell align="center">{row.measurementLocation}</TableCell>
                                            <TableCell align="center">{row.measuringInstrument}</TableCell>
                                            <TableCell align="center">{row.consignmentId}</TableCell>
                                            <TableCell align="center">{row.lotNumber}</TableCell>
                                            <TableCell align="center">{row.restricted}</TableCell>
                                            <TableCell align="center">{row.measured_quantity}</TableCell>
                                            <TableCell align="center">{row.toleranceLimit}</TableCell>
                                            <TableCell align="center">{row.createdBy} </TableCell>
                                            <TableCell align="center">{row.recordedQuantity} </TableCell>
                                            <TableCell align="center" style={{ background: '#62b6ff' }}>
                                                {row.actionTakenClosureReport}
                                            </TableCell>
                                            <TableCell align="center" style={{ background: '#62b6ff' }}>{row.reviewAndApprovedBy}</TableCell>
                                            <TableCell align="center" style={{ background: '#62b6ff' }}>{row.reviewAndApprovedOn}</TableCell>
                                            <TableCell align="center" style={{ background: '#62b6ff' }}>{row.status}</TableCell>
                                            {row.status == "Open" || row.status == "Clarification" ?
                                                <TableCell align='center' style={{ background: '#62b6ff' }}>
                                                    <Button color="secondary" variant="outlined" size="small" component={RouterLink} to={`IssueATCReview/${row.issueNumber}`}> Review </Button>
                                                </TableCell>
                                                :
                                                <TableCell align='center' style={{ background: '#62b6ff' }}> - </TableCell>}
                                        </TableRow>
                                    ))}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 35 * emptyRows }}>
                                            <TableCell colSpan={4} />
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Scrollbar>
                        {rows.length > 0 && (
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={allIssues.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                showFirstButton showLastButton
                            />
                        )}
                    </TableContainer> */}
                </Card>
            </Container>
        </>
    )
}

export default IssueATC